"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Babyjubjub = void 0;
const circomlibjs_1 = require("@railgun-community/circomlibjs");
class Babyjubjub {
    static packPoint = circomlibjs_1.babyjub.packPoint;
    static unpackPoint = circomlibjs_1.babyjub.unpackPoint;
}
exports.Babyjubjub = Babyjubjub;
